import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MyHttpClient } from '../http-client';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../http-client";
var RedeemService = /** @class */ (function () {
    function RedeemService(http) {
        this.http = http;
        this.rulesUrl = environment.server + '/api/redeem/rules';
        this.ruleUrl = environment.server + '/api/redeem/rule';
    }
    // Mirrors the legacy fetchAll call: a flat query-param object
    // (active, limit, offset, sort, <field>__in / <field>__regex) forwarded as-is.
    RedeemService.prototype.getRules = function (queryParams) {
        var qs = Object.keys(queryParams || {})
            .filter(function (key) { return queryParams[key] !== undefined && queryParams[key] !== null && queryParams[key] !== ''; })
            .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key]); })
            .join('&');
        var url = qs ? this.rulesUrl + "?" + qs : this.rulesUrl;
        return this.http.get(url).pipe(catchError(this.handleError));
    };
    RedeemService.prototype.getRule = function (ruleId) {
        return this.http.get(this.ruleUrl + "/" + ruleId).pipe(catchError(this.handleError));
    };
    RedeemService.prototype.createRule = function (rule) {
        return this.http.post(this.ruleUrl, rule).pipe(catchError(this.handleError));
    };
    // Full edit and activate/deactivate (via the `active` field) both go through editRule.
    RedeemService.prototype.updateRule = function (ruleId, rule) {
        return this.http.patch(this.ruleUrl + "/" + ruleId, rule).pipe(catchError(this.handleError));
    };
    RedeemService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        }
        else {
            console.error("Backend returned code " + error.status + ", body was:", error.error);
        }
        return throwError(error);
    };
    RedeemService.ngInjectableDef = i0.defineInjectable({ factory: function RedeemService_Factory() { return new RedeemService(i0.inject(i1.MyHttpClient)); }, token: RedeemService, providedIn: "root" });
    return RedeemService;
}());
export { RedeemService };
